import { render, staticRenderFns } from "./Descript_0.vue?vue&type=template&id=1f0131ac&scoped=true"
import script from "./Descript_0.vue?vue&type=script&lang=js"
export * from "./Descript_0.vue?vue&type=script&lang=js"
import style0 from "./Descript_0.vue?vue&type=style&index=0&id=1f0131ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0131ac",
  null
  
)

export default component.exports